import * as actionTypes from './actionTypes';
// import axios from '../../axios/Backend';

export const setRouteParams = (params) => {
  return {
    type: actionTypes.SET_ROUTE_PARAMS,
    payload: {
      params
    }
  };
};

export const updateQueryParams = (queryParams) => ({
  type: actionTypes.UPDATE_QUERY_PARAMS,//"UPDATE_QUERY_PARAMS"
  payload: {
    queryParams
  }
});

export const updateDashboardSection = (dashboardSection) => ({
  type: actionTypes.UPDATE_DASHBOARD_SECTION,//UPDATE_DASHBOARD_SECTION
  payload: {
    dashboardSection
  },
});

export const setCrmModule = (crmModule, selectionMode) => ({
  type: actionTypes.SET_CRM_MODULE,//SET_CRM_MODULE
  payload: {
    crmModule,
    selectionMode
  },
});